module.exports = __webpack_public_path__ + "resources/img/img_gridgain_apache3_jp.88add198831a9d9487f1802084b1d0f8.png";